<script setup>
// ContactDetailTabs.vue — barra de tabs principal da tela de detalhe.
// Visual estilo ClickUp Task Detail: linha de tabs com underline activo,
// icone + label, sticky logo abaixo do hero.
import { computed } from 'vue';

const props = defineProps({
  tabs: {
    type: Array,
    required: true,
    // [{ value, label, icon, count? }]
  },
  modelValue: { type: String, required: true },
});

const emit = defineEmits(['update:modelValue']);

const activeValue = computed(() => props.modelValue);

const onSelect = value => emit('update:modelValue', value);
</script>

<template>
  <nav
    class="sticky top-0 z-10 flex items-center gap-1 px-6 border-b border-n-weak bg-n-background"
  >
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      class="relative inline-flex items-center gap-2 h-11 px-3 text-sm transition-colors duration-150 ease-in-out border-0 outline-none bg-transparent"
      :class="
        activeValue === tab.value
          ? 'text-n-blue-text font-medium'
          : 'text-n-slate-11 hover:text-n-slate-12'
      "
      @click="onSelect(tab.value)"
    >
      <span :class="tab.icon" class="size-4 shrink-0" />
      <span class="truncate">{{ tab.label }}</span>
      <span
        v-if="typeof tab.count === 'number'"
        class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-[11px] rounded-full bg-n-alpha-2 text-n-slate-11"
      >
        {{ tab.count }}
      </span>
      <span
        v-if="activeValue === tab.value"
        class="absolute inset-x-3 -bottom-px h-0.5 bg-n-brand rounded-full"
      />
    </button>
  </nav>
</template>
